import $ from "jquery";



$(function() {
	$('#immo-contact-form').on("submit", function(e) {
		e.preventDefault();
		window.sendRequest();
	});
});

window.sendRequest = function() {

    var info = {
        "inquiryParameters": {
            "salutation": $('#immo-contact-form').find('select[name="anrede"]').val(),
            "firstName": $('#immo-contact-form').find('input[name="vorname"]').val(),
            "lastName": $('#immo-contact-form').find('input[name="name"]').val(),
            "street": $('#immo-contact-form').find('input[name="strasse"]').val(),
            "streetNumber": $('#immo-contact-form').find('input[name="hausnummer"]').val(),
            "postalCode": $('#immo-contact-form').find('input[name="plz"]').val(),
            "city": $('#immo-contact-form').find('input[name="ort"]').val(),
            "email": $('#immo-contact-form').find('input[name="email"]').val(),
            "phone": $('#immo-contact-form').find('input[name="telefon"]').val(),
            "comment": $('#immo-contact-form').find('textarea[name="kommentar"]').val()
        },
        "immoObjectCode": $('#immo-contact-form').find('input[name="kto"]').val()
    };


    $.ajax({
        type: "POST",
        url: "/immosolve/inquiry_of_object.php",
        data: JSON.stringify({ "info": info }),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        success: function (data) {

            if (data && data.success === true) {
                // everything worked fine
                $('#immo-contact-form').hide();
                $("#formfinished").show();
            }
            else if (data.success === false) {
                // error
                $("#formerror").show();
            }

			var x = 0;
			var y = 0;
			var form = $('#contactform');
			if(form.length > 0) {
				x = form.offset().top;
				y = form.offset().left;
			}
			$('html, body').animate({
				scrollTop: x - 70
			}, 400);

        },
        failure: function (errMsg) {
        },
        complete: function (xhr, status) {

        }
    });
}
